import Icon from '@atoms/Icon/Icon';
import Section from '@molecules/Section/Section';
import SectionContent from '@molecules/Section/SectionContent';
import { FacilitiesSection as Props } from '@type-declarations/sections';
import clsx from 'clsx';

import styles from './FacilitiesSection.module.scss';

function FacilitiesSection({
  title,
  text,
  backgroundColor,
  modifier,
  facilities,
}: Props) {
  // If no facilities available, section is not rendered
  if (!facilities?.items.length) return null;

  return (
    <Section backgroundColor={backgroundColor.color}>
      <SectionContent
        title={title}
        text={text}
        centered
        className={styles.content}
        modifier={modifier === 'inStore' ? 'inStore' : undefined}
      >
        <ul
          className={clsx(
            styles.wrapper,
            modifier && styles[modifier],
            'u-list-clean u-grid u-grid--gap-0 u-grid--gap-6@sm u-grid--2@sm',
          )}
        >
          {facilities.items.map(facility => {
            if (!facility) return null;

            return (
              <li className={styles.item} key={facility.id}>
                <span className={clsx(styles.iconContainer)} aria-hidden="true">
                  <Icon className={clsx(styles.svgIcon)} icon={facility.icon} />
                </span>
                {facility.title}
              </li>
            );
          })}
        </ul>
      </SectionContent>
    </Section>
  );
}

export default FacilitiesSection;
